import React from "react";
import { useCall } from "../context/CallContext";

const ActiveCallPanel = () => {
  const { currentCall, callStatus, endCall } = useCall();

  if (!currentCall) return null;

  const displayName =
    currentCall.calleeName || currentCall.callerName || "User";

  return (
    <div
      style={{
        position: "fixed",
        right: "20px",
        bottom: "95px",
        zIndex: 9999,
        width: "280px",
        background: "#fff",
        borderRadius: "16px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
        padding: "16px",
      }}
    >
      <div style={{ fontWeight: "700", marginBottom: "8px" }}>Call</div>
      <div style={{ fontSize: "16px", fontWeight: "600" }}>{displayName}</div>

      <div style={{ marginTop: "6px", color: "#666" }}>
        {callStatus === "calling" && "Calling..."}
        {callStatus === "ringing" && "Ringing..."}
        {callStatus === "connected" && "Connected"}
      </div>

      <button
        onClick={endCall}
        style={{
          marginTop: "14px",
          border: "none",
          background: "red",
          color: "#fff",
          padding: "10px 14px",
          borderRadius: "10px",
          cursor: "pointer",
        }}
      >
        End Call
      </button>
    </div>
  );
};

export default ActiveCallPanel;